import { useMutation } from 'react-query'
import { get } from 'framework/api/http'

interface getStarshipITConsignmentOrdersInterface {
  take?: number
  skip?: number
  principle?: any
  courier?: any
  orderStartDate?: string
  orderEndDate?: string
  consignmentStarDate?: string
  consignmentEndDate?: string
}

export const useGetStarshipITConsignmentOrders = () => {
  const mutate = useMutation(
    ({
      take,
      skip,
      principle,
      courier,
      orderStartDate,
      orderEndDate,
      consignmentStarDate,
      consignmentEndDate,
    }: getStarshipITConsignmentOrdersInterface) => {
      return get(
        `/StarshipITReports/ConsignmentOrder?Take=${take}&Skip=${skip}&Principle=${
          principle?.value === 'All' ? '' : principle?.value
        }&SubCourier=${
          courier?.value === 'All' ? '' : courier?.value
        }&OrderDateFrom=${orderStartDate}&OrderDateTo=${orderEndDate}&ConsignmentDateFrom=${consignmentStarDate}&ConsignmentDateTo=${consignmentEndDate}`,
      )
    },
  )

  return mutate
}

export default useGetStarshipITConsignmentOrders
